export default __webpack_public_path__ + "static/media/white-flag.e002ad5d.png";